import { c as _c } from "react/compiler-runtime";
import { FixedLengthArray } from '@/types/fixedLengthArray';
import { useTranslation } from 'react-i18next';
import { LinkQuestion, LinkQuestionProps } from './LinkQuestion';
import { LINKS } from '@/constants/links';
interface Props {
  topQuestions: FixedLengthArray<LinkQuestionProps & {
    categorySlug: string;
  }, 3>;
}
export function TopQuestions(props) {
  const $ = _c(11);
  const {
    t
  } = useTranslation("faq");
  let t0;
  if ($[0] !== t) {
    t0 = t("topQuestions");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h3 className="mb-10 text-center text-2xl font-bold md:mb-16 md:text-5xl">{t0}</h3>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.topQuestions) {
    t2 = props.topQuestions.map(_temp);
    $[4] = props.topQuestions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="grid gap-4 md:mb-32 md:grid-rows-3">{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <section className="mx-auto my-12 max-w-192 px-4 md:my-20">{t1}{t3}</section>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(question) {
  return <LinkQuestion key={question.slug} {...question} slug={LINKS().faqQuestion(question.categorySlug, question.slug)} />;
}